module.exports = __webpack_public_path__ + "img/jiaotong-1.e512458c.jpg";